import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { ListItem, ListItemText } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { 
  Character,
  Campaign,
} from "@dndModels";
import { User } from "@models";

// import API from "../../../utilities/system_api";
import SmartAPI from "@utilities/smart_api";
// import DandDCharacterUtilities from '../../../utilities/character_utilities';
import { makeStyles } from "@utilities/theme_utilities";

import LoadingBox from "@components/input/LoadingBox";

interface Props { 
  character: Character;
  campaign: Campaign;
}

const smart_api = SmartAPI.getInstance();

export default function CharacterCampaignInfo({ 
  character, 
  campaign, 
}: Props) {
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [players, setPlayers] = useState<User[]>([]);
  
  // passing an empty array as second argument triggers the callback in useEffect
  // only after the initial render thus replicating `componentDidMount` lifecycle behaviour
  useEffect(() => {
    if(!fetched) {
      load();
    }
  });

  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        textDecoration: "none"
      },
    });
  });
  const { classes, cx } = useStyles();

  const load = () => {
    setFetched(true);
    if (smart_api.apis.user) {
      setLoading(true);
      const filter = {
        "_id*ObjectIDs": [campaign.owner_id, ...campaign.player_ids]
      };
      smart_api.apis.user.getObjects({
        data_type: "user", 
        filter,
        ignore_templates: false
      }).then(res2 => {
        if (res2) {
          setPlayers(res2 as User[]);
          setLoading(false);
        }
      });
    }
  }

  const renderCharacters = () => {
    return campaign.characters.filter(o => o.active && !o.is_archived && o._id !== character._id).map(char => {
      const owner = players.find(o => o._id === char.owner_id);
      return (
        <Grid key={char._id} container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <ListItem className="curvedButton">
              <NavLink to={`/character/details/${char._id}`} target="_blank" rel="noopener noreferrer"
                className={cx(classes.root, "MyButton")}>
                <ListItemText primary={char.name} className="marginLeft" />
              </NavLink>
            </ListItem>
          </Grid>
          { owner && 
            <Grid
              className="small_label gray"
              size={{
                xs: 12
              }}>
              { owner.profile_name }
            </Grid>
          }
        </Grid>
      );
    });
  }
  
  if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    return (
      <div style={{ 
        height: "100%",
        overflowX: "hidden"
      }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <ListItem className="curvedButton">
              <NavLink to={`/campaign/details/${campaign._id}`} target="_blank" 
                className={cx(classes.root, "MyButton")}>
                <ListItemText primary={`Campaign: ${campaign.name}`} className="marginLeft" />
              </NavLink>
            </ListItem>
          </Grid>
          { renderCharacters() }
        </Grid>
      </div>
    );
  }
}

